import {ErrorDTO} from '../../../submodule/model/error-dto.model';

export class ErrorSerializerService {

  public static toErrorDTO(error: any, userMail: string, additionalContext: Record<string, any> = {}): ErrorDTO {

    const errorDTO: ErrorDTO = {
      name: error.name || this.extractErrorTypeName(error),
      message: error.message || String(error),
      timestamp: Date.now(),
      url: window.location.href,
      userAgent: navigator.userAgent,
      userEmail: userMail,
      temporalMeasure: { count: 0, duration: 0, unit: 's'}
    };

    if (error.stack) {
      errorDTO.stack = this.sanitizeStackTrace(error.stack);
    }

    try {
      if ((window as any).ng && (window as any).ng.version) {
        errorDTO.angularVersion = (window as any).ng.version.full;
      }
    } catch (e) {
      // Silently fail if version detection doesn't work
    }

    if (Object.keys(additionalContext).length > 0) {
      errorDTO.metadata = this.sanitizeObject(additionalContext);
    }

    return errorDTO;
  }


  private static extractErrorTypeName(error: any): string {
    if (error === null) return 'NullError';
    if (error === undefined) return 'UndefinedError';
    if (error instanceof Error) return error.constructor.name;
    return typeof error === 'object' ? 'ObjectError' : typeof error + 'Error';
  }

  private static sanitizeStackTrace(stack: string): string {
    // Remove potential sensitive information (like local file paths)
    let sanitized = stack.replace(/\(\/Users\/[^)]+\)/g, '(...)');
    sanitized = sanitized.replace(/\(C:\\Users\\[^)]+\)/g, '(...)');
    return sanitized.substring(0, 2000);
  }

  private static sanitizeObject(obj: any): any {
    if (!obj) return obj;

    const seen = new WeakSet();

    return JSON.parse(JSON.stringify(obj, (key, value) => {
      if (typeof value === 'object' && value !== null) {
        if (seen.has(value)) {
          return '[Circular Reference]';
        }
        seen.add(value);
      }

      if (typeof value === 'string' && value.length > 1000) {
        return value.substring(0, 1000) + '... [truncated]';
      }

      if (value instanceof RegExp) return value.toString();
      if (value instanceof Map) return Array.from(value.entries());
      if (value instanceof Set) return Array.from(value.values());

      return value;
    }));
  }
}
